import { useState, useEffect, lazy, Suspense, useTransition , useRef} from "react";
import { useDispatch, useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
// import { Tooltip } from "react-tooltip";
import "../../../../node_modules/react-tooltip/dist/react-tooltip.css";
import control from "../../../assets/images/others/control.png";
import { useTranslation } from "react-i18next";
import { width } from "@mui/system";
import Footer from "./Footer";
import AddReciept from "../roles/spoc/AddReciept";
import "./sidebar.css";
import {
  List,
  Collapse,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  IconButton,
  Tooltip,
} from "@mui/material";
import MuiDrawer from "@mui/material/Drawer";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ViewFeedbackDetails from "../pages/feedbackDetails/ViewFeedbackDetails";
import { useRefreshState } from "../../hooks/useRefreshState";
import Navbar from "./Navbar/Navbar";
import { ExpandLess, ExpandMore, StarBorder } from "@mui/icons-material";
import { styled, useTheme } from "@mui/material/styles";
import { applicationContextRoot } from "../../../constants/constants";
import { setReloadFeedbackDetails } from "../../system/redux/reducers/reloadFeedbackDetails.jsx";
import loadingSvg from "../../../assets/GIF/loading.gif";
import { setNavigationData, setPayloadData } from "../../system/redux/reducers/NavigatedDataReducer.jsx";
import SessionTimeoutProvider, {
  useSessionTimeout,
} from "../../hooks/useSessionTimeout.jsx";

const drawerWidth = 240;
const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const SideBar = () => {
  //useRefreshState();
  const isAuthenticated = useSelector(
    (state) => state.userState.isAuthenticated
  );

  const isSessionValid = SessionTimeoutProvider();

  const theme = useTheme();
  const stateRole = useSelector((state) => state.role);
  let userRole = isAuthenticated && stateRole ? stateRole : null;
  console.log(userRole);
  let roles = null;
  if (isAuthenticated)
    roles = userRole?.userCurrRole?.description.split("_").pop().toLowerCase();
  console.log(roles);
  const dispatch = useDispatch();
  const Dashboard = lazy(() => import("./../roles/" + roles + "/dashboard"));
  const AddFeedback = lazy(() =>
    import("./../roles/" + roles + "/AddFeedback")
  );
  // const QuickLogIssue = lazy(() => import('./../pages/feedback/QuickLogIssue'));
  const ViewFeedback = lazy(() =>
    import("./../roles/" + roles + "/feedback/ViewFeedback")
  );
  const CloseFeedback = lazy(() =>
    import("./../roles/" + roles + "/feedback/CloseFeedback")
  );
  const AcceptFeedback = lazy(() =>
    import("./../roles/" + roles + "/feedback/AcceptFeedback")
  );
  const QuickLogIssue = lazy(() =>
    import("./../pages/feedback/QuickLogIssue.jsx")
  );
  const SearchFeedback = lazy(() =>
    import("./../roles/" + roles + "/feedback/SearchFeedback")
  );
  const Attribute = lazy(() =>
    import("./../roles/" + roles + "/master/Attribute")
  );
  const Department = lazy(() =>
    import("./../roles/" + roles + "/master/Department")
  );
  const FeedbackSource = lazy(() =>
    import("./../roles/" + roles + "/master/FeedbackSource")
  );
  const MasterArea = lazy(() =>
    import("./../roles/" + roles + "/master/MasterArea")
  );
  const SubArea = lazy(() => import("./../roles/" + roles + "/master/SubArea"));
  const AddRule = lazy(() => import("./../pages/master/AddRule"));
  debugger;
  const MISReport = lazy(() => import("./../pages/report/MISReport"));
  const MISMultiDeptReport = lazy(() => import("./../pages/report/MISMultiDeptReport"));
  const AreaOfConcernReport = lazy(() => import("./../pages/report/AreaOfConcernReport"));
  const BulkResolve = lazy(() => import("./../pages/feedback/BulkResolve"));
  const BulkClose = lazy(() => import("./../pages/feedback/BulkClose"));
  const G8Report = lazy(() => import("./../pages/report/G8Report"));
  const CallbackReport = lazy(() => import("./../pages/report/CallbackReport"));
  const AddCustomerUser = lazy(() =>
    import("./../roles/" + roles + "/user/AddCustomerUser")
  );
  const AddUserInternal = lazy(() =>
    import("./../roles/" + roles + "/user/AddUserInternal")
  );
  const DefineAuthorization = lazy(() =>
    import("./../roles/" + roles + "/user/DefineAuthorization")
  );
  const AssigneeGroup = lazy(() =>
    import("./../roles/" + roles + "/user/AssiGneeGroup")
  );
  const EscalationMatrix = lazy(() =>
    import("./../roles/" + roles + "/configuration/EscalationMatrix")
  );
  const ViewSurvey = lazy(() => import("./../pages/survey/ViewSurvey.jsx"));

  const { i18n, t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(99);
  const [subMenu, setSubMenu] = useState(0);
  const { menuItems } = useSelector((state) => state.menu);
  const menus = useSelector((state) => state.menu);
  const navigate = useNavigate();
  const [activeComponent, setActiveComponent] = useState("");
  const [previousComponent, setPreviousComponent] = useState("dashboard");
  const path = [t("label.general.navigation.home")];
  const [sidebarMenuOpen, setSidebarMenuOpen] = useState(null);
  const { navigationPath, data } = useSelector((state) => state.navigate);
  const dashboardToggleRef = useRef(null); // ← add this
  const [reloadKey, setReloadKey] = useState(0);
 const Dashboardtoggle = () => {
  debugger;

  const navigationInfo = {
    navigationPath: "dashboard",
    navigationSubPath: "All",
    data: {}
  };

  // ✅ switch component to dashboard
  setPreviousComponent(activeComponent);
  setActiveComponent("dashboard");

  // ✅ update redux (VERY IMPORTANT)
  dispatch(setReloadFeedbackDetails({ switchToDashboardView: true }));
  dispatch(setNavigationData(navigationInfo));
};
  useEffect(() => {
    if (menus?.menuItems.length > 0) {
      setSidebarMenuOpen(menus.menuItems.map((menu) => false));
    }
  }, [menus]);
  useEffect(() => {
    debugger;
    setActiveComponent(navigationPath);
  }, []);
  /*
  const handleComponentChange = (componentName) => {
    debugger;
    const navigationInfo = {
      'navigationPath': componentName,
      'navigationSubPath': "All",
      'data': {}
    }
    setPreviousComponent(activeComponent);
    if (componentName == "dashboard") {
      setActiveComponent(componentName);
      dispatch(setReloadFeedbackDetails({ switchToDashboardView: true }));
      //dispatch(setPayloadData({}));
    }
    setActiveComponent(componentName);
    dispatch(setNavigationData(navigationInfo));
  };
  */
  const handleComponentChange = (componentName) => {
    debugger;

    const navigationInfo = {
      navigationPath: previousComponent,
      navigationSubPath: "All",
      data: {}
    };

    if (activeComponent === componentName) {
      // 🔥 SAME component → force reload
      setReloadKey(prev => prev + 1);
    } else {
      setPreviousComponent(activeComponent);
      setActiveComponent(componentName);
    }

    if (componentName === "dashboard") {
      dispatch(setReloadFeedbackDetails({ switchToDashboardView: true }));
    }

    dispatch(setNavigationData(navigationInfo));
  };

  let componentToRender;

  switch (activeComponent) {
    case "AddFeedback":
      componentToRender = (
        <AddFeedback
          key={reloadKey}
          path={[...path, t("menu.key.feedback"), t("menu.key.feedback.add")]}
        />
      );
      break;
    case "AddReceipt":
      componentToRender = (
        <AddReciept
          key={reloadKey}
          path={[...path, t("menu.key.feedback"), t("menu.key.receipt.add")]}
        />
      );
      break;
    case "QuickLogIssue":
      componentToRender = (
        <QuickLogIssue
          key={reloadKey}
          path={[...path, t("menu.key.feedback"), t("menu.key.quickLog")]}
          size={{
            select: 60,
            searchCri: 140,
            Customer: 140,
            Client: 145,
            feedback_desc: 160,
            area: 140,
            responseToLogger: 150,
            add: 70,
          }}
        />
      );
      break;
    case "ViewFeedback":
      componentToRender = (
        <ViewFeedback
          key={reloadKey}
          path={[...path, t("menu.key.feedback"), t("menu.key.feedback.view")]}
          size={{
            select_mul: 60,
            sl_no: 80,
            f_code: 130,
            f_desc: 120,
            f_type: 130,
            dept: 120,
            org: 120,
            marea: 120,
            sarea: 120,
            mbno: 120,
            m_y_ofFeedback: 200,
            cl_date: 160,
            status: 120,
            c_satisfaction: 110,
            d_reopen: 130,
            f_date: 140,
            action: 115,
          }}
        />
      );
      break;
    case "CloseFeedback":
      componentToRender = <CloseFeedback />;
      break;
    case "SearchFeedback":
      componentToRender = <SearchFeedback />;
      break;
    case "AddRule":
      componentToRender = <AddRule />;
      break;
    case "Attribute":
      componentToRender = (
        <Attribute
          key={reloadKey}
          path={[...path, t("menu.key.master"), t("menu.key.master.attribute")]}
        />
      );
      break;
    case "Department":
      componentToRender = (
        <Department
          key={reloadKey}
          path={[
            ...path,
            t("menu.key.master"),
            t("menu.key.master.department"),
          ]}
        />
      );
      break;
    case "FeedbackSource":
      componentToRender = (
        <FeedbackSource
          key={reloadKey}
          path={[
            ...path,
            t("menu.key.master"),
            t("menu.key.master.feedbackSource"),
          ]}
        />
      );
      break;
    case "MasterArea":
      componentToRender = (
        <MasterArea
          key={reloadKey}
          path={[...path, t("menu.key.master"), t("menu.key.master.attribute")]}
        />
      );
      break;
    case "SubArea":
      componentToRender = (
        <SubArea
          key={reloadKey}
          path={[...path, t("menu.key.master"), t("menu.key.master.attribute")]}
        />
      );
      break;
    case "MISReport":
      debugger;
      componentToRender = (
        <MISReport key={reloadKey} path={[...path, "Abdul Bari", t("menu.key.report.mis")]} />
      );
      break;
    case "MISMultiDeptReport":
      componentToRender = (
        <MISMultiDeptReport
          key={reloadKey}
          path={[...path, t("menu.key.report.misrawdump.multi.dept")]}
        />
      );
      break;
    case "AreaOfConcernReport":
      componentToRender = (
        <AreaOfConcernReport key={reloadKey} path={[...path, "", t("menu.key.report.area.of.concern")]} />
      );
      break;
    case "BulkResolve":
      componentToRender = (
        <BulkResolve  key={reloadKey} path={[...path, "", t("menu.key.feedback.bulk.resolve")]} 
        dashboardToggle={Dashboardtoggle}/>
      );
    break;
    case "BulkClose":
      componentToRender = (
        <BulkClose key={reloadKey} path={[...path, "", t("menu.key.feedback.bulk.close")]} />
      );
    break;

    case "G8Report":
      componentToRender = (
        <G8Report key={reloadKey} path={[...path, "", t("menu.key.report.g8.report")]} />
      );
      break;
      
      
    case "CallbackReport":
      componentToRender = (
        <CallbackReport
          key={reloadKey}
          path={[...path, "Abdul Bari", t("menu.key.callback.report")]}
        />
      );
      break;
    case "AddExternalUser":
      componentToRender = (
        <AddCustomerUser
          key={reloadKey}
          path={[...path, t("menu.key.user"), t("menu.key.user.add.external")]}
        />
      );
      break;
    case "AddInternalUser":
      componentToRender = (
        <AddUserInternal
          key={reloadKey}
          path={[...path, t("menu.key.user"), t("menu.key.user.add.internal")]}
        />
      );
      break;
    case "AssigneeGroup":
      componentToRender = (
        <AssigneeGroup
          key={reloadKey}
          path={[...path, t("menu.key.user"), t("menu.key.user.assigneeGropu")]}
          size={{
            sl_no: 5,
            assign_grp: 130,
            assign_grp_type: 120,
            uname: 100,
            first_name: 110,
            last_name: 90,
            dept: 100,
            role: 90,
            email: 140,
            mbno: 50,
            status: 120,
            action: 10,
          }}
        />
      );
      break;
    case "AcceptFeedback":
      componentToRender = (
        <AcceptFeedback
          key={reloadKey}
          path={[
            ...path,
            t("menu.key.feedback"),
            t("general.label.assignedFeedback"),
          ]}
          size={{
            select_mul: 60,
            sl_no: 80,
            f_code: 130,
            f_desc: 120,
            f_type: 130,
            dept: 120,
            org: 120,
            marea: 120,
            sarea: 120,
            mbno: 120,
            m_y_ofFeedback: 200,
            cl_date: 160,
            status: 120,
            c_satisfaction: 110,
            d_reopen: 130,
            f_date: 140,
            action: 115,
          }}
        />
      );
      break;
    case "dashboard":
      componentToRender = (
        <Dashboard key={reloadKey} path={[...path, t("menu.key.dashboard")]} />
      );
      break;
    case "EscalationMatrix":
      componentToRender = (
        <EscalationMatrix
          key={reloadKey}
          path={[
            ...path,
            t("menu.key.configuration"),
            t("menu.key.escalation.matrix"),
          ]}
          size={{
            sl_no: 60,
            master_area: 130,
            sub_area: 120,
            assignment_sla: 130,
            pickup_sla: 110,
            resolver_grp: 180,
            resolution_sla: 100,
            escalation_level: 90,
            action: 115,
          }}
        />
      );
      break;

    case "ViewFeedbackDetails":
      componentToRender = (
        <ViewFeedbackDetails key={reloadKey} path={[...path, t("menu.key.user")]} />
      );
      break;
    case "DefineAuthorization":
      componentToRender = (
        <DefineAuthorization
          key={reloadKey}
          path={[...path, t("label.defineAuthorization.page.title")]}
        />
      );
      break;
    case "ViewSurvey":
      componentToRender = (
        <ViewSurvey
          key={reloadKey}
          path={[
            ...path,
            "bari",
            t("menu.key.survey"),
            t("menu.key.survey.view"),
          ]}
          size={{
            sl_no: 60,
            department_name: 130,
            survey_name: 120,
            survey_start_date: 130,
            survey_end_date: 130,
            submit_count: 60,
            passed_survey: 60,
            failed_survey: 60,
            action: 100,
          }}
          dashboardToggle={Dashboardtoggle}
        />
      );
      break;
    default:
      componentToRender = (
        <Dashboard key={reloadKey} path={[...path, t("menu.key.dashboard")]} />
      );
      break;
  }
  console.log(userRole, componentToRender);
  useEffect(() => {
    // console.log(roles);
    // let crl = roles.userCurrRole ? roles.userCurrRole.description : "";
    // let prefix = roles.userCurrRole ? roles.userCurrRole.department.description : "";
    // if (crl.toUpperCase().includes('CUSTOMER')) {
    //     setCurrRole((crl.substring(crl.indexOf('_') + 1)).toUpperCase());
    // }
    // else {
    //     setCurrRole((prefix + " - " + crl.substring(crl.indexOf('_') + 1)).toUpperCase());
    // }
    // setEmail(roles.userEmail);
    // setUserName(roles.userName);
    if (!isAuthenticated) {
      navigate(applicationContextRoot);
    }
  }, [roles, isAuthenticated]);
  if (isAuthenticated) {
    return (
      <div className="tw-flex">
        <div
          className={` ${open ? "tw-w-60" : "tw-w-14 "
            } custom-sidebar tw-relative tw-duration-700 `}
        >
          <DrawerHeader>
            <IconButton
              className="text-white"
              // sx={{ fontSize: "1.5rem!important" }}
              onClick={() => {
                if (open === true) {
                  setSidebarMenuOpen(sidebarMenuOpen.map(() => false));
                }
                setOpen(!open);
              }}
            >
              {!open ? <i class="ti ti-menu-2"></i> : <ChevronLeftIcon />}
            </IconButton>
          </DrawerHeader>
          <List className="text-white">
            {menus.menuItems &&
              Array.isArray(menus.menuItems) &&
              menus.menuItems.map((Menu, index) => {
                // debugger;
                return (
                  <>
                    <Tooltip title={t(Menu.msgKey)} placement={"right"} arrow>
                      <ListItemButton
                        onClick={() => {
                          if (index === 0) {
                            handleComponentChange("dashboard");
                            return;
                          }
                          setOpen(true);

                          setSidebarMenuOpen((prev) => {
                            let newSidebarMenuOpen = [...sidebarMenuOpen];
                            for (
                              let i = 0;
                              i < newSidebarMenuOpen.length;
                              i++
                            ) {
                              if (i !== index) {
                                newSidebarMenuOpen[i] = false;
                              }
                            }
                            newSidebarMenuOpen[index] =
                              !newSidebarMenuOpen[index];
                            return newSidebarMenuOpen;
                          });
                        }}
                      >
                        <ListItemIcon
                          className="me-3 text-white"
                          sx={{ minWidth: "0" }}
                        >
                          <FontAwesomeIcon className="fa-lg" icon={Menu.icon} />
                        </ListItemIcon>
                        <ListItemText
                          className="text-white text-nowrap"
                          sx={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                          primary={t(Menu.msgKey)}
                        />
                        {open && index !== 0 ? (
                          sidebarMenuOpen[index] ? (
                            <ExpandLess />
                          ) : (
                            <ExpandMore />
                          )
                        ) : (
                          <></>
                        )}
                      </ListItemButton>
                    </Tooltip>

                    {sidebarMenuOpen && (
                      <Collapse
                        in={sidebarMenuOpen[index]}
                        timeout={"auto"}
                        unmountOnExit
                        className="ms-2"
                      >
                        {Menu.subMenus &&
                          Array.isArray(Menu.subMenus) &&
                          Menu.subMenus.length > 0 &&
                          Menu.subMenus.map((subMenuEle, idx) => (
                            <Tooltip
                              title={t(subMenuEle.msgKey)}
                              placement={"right"}
                              arrow
                            >
                              <ListItemButton
                                onClick={() => {
                                  setOpen(false);
                                  setSidebarMenuOpen((prev) => {
                                    let newSidebarMenuOpen = [
                                      ...sidebarMenuOpen,
                                    ];
                                    for (
                                      let i = 0;
                                      i < newSidebarMenuOpen.length;
                                      i++
                                    ) {
                                      if (i !== index) {
                                        newSidebarMenuOpen[i] = false;
                                      }
                                    }
                                    newSidebarMenuOpen[index] =
                                      !newSidebarMenuOpen[index];
                                    return newSidebarMenuOpen;
                                  });
                                  handleComponentChange(
                                    subMenuEle.defaultText.replaceAll(" ", "")
                                  );
                                  setId(subMenuEle.id);
                                }}
                              >
                                <ListItemIcon
                                  className="me-1 text-white"
                                  sx={{ minWidth: "0" }}
                                >
                                  <FontAwesomeIcon icon={subMenuEle.icon} />
                                </ListItemIcon>
                                <ListItemText
                                  className="text-white text-nowrap"
                                  sx={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  <span>{t(subMenuEle.msgKey)}</span>
                                </ListItemText>
                              </ListItemButton>
                            </Tooltip>
                          ))}
                      </Collapse>
                    )}
                  </>
                );
              })}
          </List>
        </div>

        <div
          className="custom-backdrop-area"
          onClick={() => {
            if (open === true) {
              setSidebarMenuOpen(sidebarMenuOpen.map(() => false));
            }
            setOpen(!open);
          }}
        ></div>

        <div className="full-content-area">
          {/* PageTitleContainer to be added here */}
          <Navbar handleDashboardClick={handleComponentChange} />
          <Suspense
            fallback={
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: "100vh" }}
              >
                <img src={loadingSvg} alt="Loading..." />
              </div>
            }
          >
            {componentToRender}
          </Suspense>
          <div className="AlignHorizontalCenter mt-auto">
            <Footer className="AlignHorizontalCenter" />
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <img src={loadingSvg} alt="Loading..." />
      </div>
    );
  }
};
export default SideBar;
